import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SharedModule } from '@shared/modules/shared.module';

@Component({
	selector: 'app-button',
	imports: [SharedModule],
	templateUrl: './button.component.html',
	styleUrl: './button.component.scss',
})
export class ButtonComponent {
	@Input() label = '';
	@Input() icon?: string;
	@Input() disabled = false;
	@Input() loading = false;
	@Input() size: 'large' | 'medium' | 'small' | 'xsmall' = 'medium';
	@Input() variant:
		| 'primary'
		| 'secondary'
		| 'tertiary'
		| 'dark'
		| 'outlined'
		| 'flat'
		| 'icon-only'
		| 'icon-only-secondary'
		| 'icon-ghost'
		| 'ghost'
		| 'link' = 'primary';
	@Input() type: 'button' | 'submit' | 'reset' = 'button';
	@Input() routerLink?: string | string[];
	@Input() color: string | null = null;

	@Output() onClick = new EventEmitter<Event>();

	handleClick(event: Event): void {
		if (!this.disabled && !this.loading) {
			this.onClick.emit(event);
		}
	}

	get isIconOnly(): boolean {
		return !!this.icon && !this.label;
	}

	get isDisabled(): boolean {
		return this.disabled && !this.loading;
	}

	getButtonClasses(): string[] {
		const classes = ['custom-button', this.size, this.variant];
		if (this.isIconOnly) {
			classes.push('icon-only');
		}
		if (this.loading) {
			classes.push('loading');
		}
		if (this.color) {
			classes.push('has-custom-color');
		}
		return classes;
	}
}
